function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createSelector } from 'reselect';
import isProductFullDesign from 'swag-common/utils/custom-store-product/product-is-full-design.util';
const productVariantsSelector = state => state.relatedProduct.product.variants;
const productLoadedSelector = state => state.relatedProduct.productLoaded;
const isFullDesignProductSelector = state => isProductFullDesign(state.relatedProduct.product);
const imagesWithoutImprintAreaSelector = state => state.relatedProduct.product.imagesWithoutImprintArea;
const variantIndexSelector = state => state.relatedProduct.variantIndex;
const sizeIndexSelector = state => state.relatedProduct.sizeIndex;
const viewTypeSelector = state => state.relatedProduct.view;
const sizeDependentImagesSelector = state => state.relatedProduct.product.sizeDependentImages;
export const fullScreenModeSelector = state => state.relatedProduct.fullScreenMode;

// get images from all selected variants.
const selectedVariantsImagesSelector = createSelector(sizeIndexSelector, viewTypeSelector, variantIndexSelector, productVariantsSelector, productLoadedSelector, sizeDependentImagesSelector, imagesWithoutImprintAreaSelector, isFullDesignProductSelector, (sizeIndex, view, variantIndex, variants, productLoaded, sizeDependentImages, imagesWithoutImprintArea, isFullDesignProduct) => {
  if (!productLoaded) {
    return [];
  }
  if (isFullDesignProduct) {
    return imagesWithoutImprintArea.map(images => _objectSpread({}, images, {
      variantIndex
    }));
  } // return imagesWithoutImprintArea if there are no variants.

  const imageSizeIndex = sizeDependentImages ? sizeIndex : 0;
  const {
    images
  } = mergeImages(variants.find(item => item.index === variantIndex), imagesWithoutImprintArea, view, imageSizeIndex, variantIndex);
  return images.sort(({
    isImageWithImprintArea
  }) => isImageWithImprintArea ? -1 : 1);
});
export const activeProductImageSelector = createSelector(selectedVariantsImagesSelector, viewTypeSelector, variantIndexSelector, (currentImages, view, variantIndex) => {
  const activeProductImage = currentImages.find(image => {
    const isSameView = view === image.id;
    const isSameVariant = variantIndex === image.variantIndex;
    return isSameView && isSameVariant;
  });
  if (!activeProductImage) {
    return currentImages[0];
  }
  return activeProductImage;
});

// merge images with imprint area with images without imprint area
const mergeImages = (variant, imagesWithoutImprintArea, view, sizeIndex, variantIndex) => {
  const images = variant && variant.images || [];
  let imagesWithoutImprintAreaType = [];
  if (imagesWithoutImprintArea) {
    imagesWithoutImprintAreaType = imagesWithoutImprintArea.filter(image => image).map(image => _objectSpread({}, image, {
      isImageWithImprintArea: false,
      variantIndex
    }));
  }
  const imagesWithImprintAreaType = Object.keys(images).map(viewName => {
    if (!images[viewName]) {
      return null;
    }
    return _objectSpread({}, images[viewName][sizeIndex], {
      isImageWithImprintArea: true,
      variantIndex,
      id: viewName
    });
  });
  const allImages = [...imagesWithImprintAreaType, ...imagesWithoutImprintAreaType].filter(image => image !== null && image.url !== '');
  return {
    images: allImages
  };
};